import React, { useEffect, useState, useRef } from "react";
import {
  call,
  countryArr,
  backBtnBlack,
  Logo
} from "../../assets/img";
import { useNavigate } from "react-router-dom";

import "react-international-phone/style.css";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import { ICON_FILTER, URLS } from "../../Services/Constant";
import { post } from "../../Services/ApiHandler";
import { Toast } from "../../Component/Toast";
import countryData from "../../Services/CountryData.json";
import SubmitButton from "../../Component/SubmitButton";
import { MaskIcon } from "../../Component/MaskIcon";

const Forgot = () => {
  const navigate = useNavigate();
  const firstOtpRef = useRef(null);
  const [timer, setTimer] = useState(60);
  const [isResendEnabled, setIsResendEnabled] = useState(false);
  const [isLoading, setIsloading] = useState(false);
  const [isLoading2, setIsloading2] = useState(false);
  const [mobile, setMobile] = useState("");
  const [errors, setErrors] = useState({ email: "", password: "", mobile: "" });
  const [countryCode, setCountryCode] = useState("+91");
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [showOtp, setShowOtp] = useState(false);
  const [isValidForm, setIsValidForm] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(countryData.find(c => c.iso === 'IN') || countryData[0]);



  const maxLength = selectedCountry?.maxLength;
  //   console.log("maxLength", maxLength);

  const validatePhone = (value, countryCode = "IN") => {
    const phoneNumber = parsePhoneNumberFromString(value, countryCode);
    return phoneNumber ? phoneNumber.isValid() : false;
  };

  const handleMobileChange = (e) => {
    const value = e.target.value.replace(/[^\d]/g, '');
    if (value.length <= maxLength) {
      setMobile(value);
      setErrors(prev => ({ ...prev, mobile: "" }));
    }
  };

  const handleCountrySelect = (country) => {
    setMobile('')
    setSelectedCountry(country);
    setCountryCode(country.code);
    setDropdownOpen(false);
  };

  useEffect(() => {
    let interval = null;
    if (showOtp && timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else if (timer === 0) {
      setIsResendEnabled(true);
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [showOtp, timer]);


  const handleResendOtp = () => {
    if (!isResendEnabled) return;
    handleSendOtp(new Event("resend"));
    setTimer(60);
    setIsResendEnabled(false);
  };


  useEffect(() => {
    const phoneOk = validatePhone(mobile, countryCode) || mobile.length >= 10;
    setIsValidForm(phoneOk);
  }, [mobile, countryCode]);

  useEffect(() => {
    if (showOtp && firstOtpRef.current) {
      firstOtpRef.current.focus();
    }
  }, [showOtp]);

  const handleChange = (value, index) => {
    if (/^[0-9]?$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      // move to next input when user types a number
      if (value && index < 3) {
        const next = document.getElementById(`otp-${index + 1}`);
        if (next) next.focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      e.preventDefault();
      const newOtp = [...otp];

      if (otp[index]) {
        // clear current field if it has a value
        newOtp[index] = "";
        setOtp(newOtp);
      } else if (index > 0) {
        // move to previous input if current is already empty
        const prev = document.getElementById(`otp-${index - 1}`);
        if (prev) prev.focus();
        newOtp[index - 1] = "";
        setOtp(newOtp);
      }
    }
  };


  const handleSendOtp = async (e) => {
    e.preventDefault();

    const newErrors = {};

    if (!validatePhone(mobile, countryCode)) {
      newErrors.mobile = "Enter a valid phone number";
    } else if (mobile.length < 10) {
      newErrors.mobile = "Phone number must be at least 10 digits";
    }

    const cleanMobile = mobile.replace(countryCode, "").replace(/[^\d]/g, "");
    const formdata = {
      mobile: cleanMobile,
      country_code: countryCode,
    }
    setIsloading(true);
    try {
      const res = await post(URLS.FORGOTPASSWORD, formdata);
      //       console.log("res OTP sent", res);
      if (res.status === "success") {
        Toast(res.message || "OTP sent successfully!");
        setErrors({});
        setIsloading(false);
        setShowOtp(true);
        setTimer(60);
        setIsResendEnabled(false);
        // alert(`OTP: ${res?.otp}`);
      }
    } catch (err) {
      //       console.log('forgot err', err);
      setErrors(newErrors);
      setIsloading(false);
    } finally {
      setIsloading(false);
    }
  };

  const handleConfirm = async (e) => {
    e.preventDefault();

    const enteredOtp = otp.join("").trim();

    if (enteredOtp.length !== 4) {
      Toast("Please enter a valid 4-digit OTP");
      return;
    }

    const cleanMobile = mobile.replace(countryCode, "").replace(/[^\d]/g, "");

    const formdata = {
      mobile: cleanMobile,
      country_code: countryCode,
      otp: enteredOtp,
    };
    setIsloading2(true)
    try {
      const res = await post(URLS.VERIFYOTP, formdata);
      //       console.log("OTP verify response:", res);

      if (res.status === "success") {
        Toast(res.message || "OTP verified successfully!");
        setIsloading2(false);
        navigate("/create-password", { state: { admin_id: res?.admin_id } });
      } else {
        setIsloading2(false);
        Toast(res.message || "Invalid OTP, please try again.");
      }
    } catch (err) {
      setIsloading2(false);
      console.error("OTP verify error:", err);
      Toast("Something went wrong while verifying OTP");
    } finally {
      setIsloading2(false);
    }
  };


  return (
    <div className=" login-page">
      
      <div className="row min-vh-100">
        <div className="col-lg-6 d-flex ac-jc login-left">
          <img src={Logo} className="img-fluid logo" alt="Logo" />
        </div>

        <div className="col-lg-6 login-right">

          <form style={{
            // height: "80%", 
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-end',
            position: "absolute",
            padding: "0 30px"
          }} className="login-form">

            <span style={{ display: "flex", gap: '25px' ,marginBottom:25}} onClick={() => navigate(-1)}>
              <img
                className="pointer backinage"
                src={backBtnBlack}
                height={18}
                width={18}
                style={{ marginTop: '3.5px' }}
              />
              <h2
                style={{ color: "black" ,fontSize:'20px' }}
                className=" login-title f3 fs-sm-18  fs-xxl-26"
              >
                Forgot password
              </h2>
            </span>

            <div className="form-group text-start">
              <label style={{ color: '#8F0D3d' }} className="form-label f3 mb-0">
                Mobile Number
              </label>
              <div
                className="login-input mt-1"
                style={{
                  height: 50,
                  background: "#F0EDE6",
                  display: "flex",
                  alignItems: "center",
                  borderRadius: 8,
                  position: 'relative',
                }}
              >
                {/* Country Code Button */}
                <button
                  type="button"
                  onClick={() => setDropdownOpen(!dropdownOpen)}
                  style={{
                    backgroundColor: '#6E6E6E',
                    border: '1px solid #8F0D3dCC',
                    color: '#ffffff',
                    fontSize: 16,
                    width: 60,
                    height: 50,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 4,
                    cursor: 'pointer',
                    borderRadius: '8px 0 0 8px',
                    position: 'relative',
                    padding: "0 34px",
                  }}
                >
                  <img src={countryArr} alt="country dropdown arrow" style={{ width: 15, height: 9 }} />
                  {selectedCountry.code}
                </button>

                {/* Phone Input */}
                <input
                  type="number"
                  placeholder="Mobile Number"
                  className="placholdercolorchanges"
                  value={mobile}
                  onChange={handleMobileChange}
                  style={{
                    flex: 1,
                    border: 'none',
                    outline: 'none',
                    backgroundColor: 'transparent',
                    fontSize: 16,
                    color: '#1B1B1B',
                    padding: '0 10px',
                    height: 50,
                  }}
                />

                <MaskIcon src={call} alt="call icon" style={{ marginRight: 12, width: 20, top: 1, position: 'relative'}} />

                {/* Dropdown */}
                {dropdownOpen && (
                  <div
                    style={{
                      position: 'absolute',
                      top: 52,
                      left: 0,
                      right: 0,
                      backgroundColor: '#ffffff',
                      border: '1px solid rgb(0 71 67 / 40%)',
                      borderRadius: 8,
                      maxHeight: 200,
                      overflowY: 'auto',
                      zIndex: 1000,
                    }}
                  >
                    {countryData.map((country) => (
                      <div
                        key={country.iso}
                        onClick={() => handleCountrySelect(country)}
                        style={{
                          padding: '10px',
                          cursor: 'pointer',
                          borderBottom: '1px solid rgb(0 71 67 / 40%)',
                          backgroundColor: selectedCountry.iso === country.iso ? '#ffffff' : '#F0EDE6',
                        }}
                      >
                        {country.name}
                      </div>
                    ))}
                  </div>
                )}
              </div>
              {errors.mobile && <p className="err">{errors.mobile}</p>}
            </div>

            {!showOtp &&
              // <button
              //   type="button"
              //   className="login-btn f3 f2"
              //   onClick={handleSendOtp}
              //   disabled={!isValidForm || isLoading}
              //   style={{
              //     opacity: isValidForm && !isLoading ? 1 : 0.6,
              //     cursor: isValidForm && !isLoading ? "pointer" : "not-allowed",
              //     display: "flex",
              //     alignItems: "center",
              //     justifyContent: "center",
              //     gap: "8px",
              //     color: 'black'
              //   }}
              // >
              //   {isLoading ? (
              //     <>
              //       <span
              //         className="spinner-border spinner-border-sm"
              //         role="status"
              //         aria-hidden="true"
              //         style={{ color: "black", padding: 9 }}
              //       ></span>
              //     </>
              //   ) : (
              //     "Send OTP"
              //   )}
              // </button>
              <SubmitButton
                onClick={handleSendOtp}
                title="Send OTP"
                style={{ marginTop: 20 , color : 'white'}}
                disabled={!isValidForm || isLoading}
                isFormValid={!isValidForm}
                loading={isLoading}
              />
            }

            {showOtp && (
              <>
                {" "}
                <p style={{ marginTop: 20 }} className=" my-3 Enter_otp f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-18 fs-xxl-20 primary">
                  Enter the OTP
                </p>
                <div className="otp-container">
                  {otp.map((digit, index) => (
                    <input
                      key={index}
                      ref={index === 0 ? firstOtpRef : null}
                      id={`otp-${index}`}
                      type="number"
                      maxLength="1"
                      value={digit}
                      onChange={(e) => handleChange(e.target.value, index)}
                      onKeyDown={(e) => handleKeyDown(e, index)}
                      className="otp-input placholdercolorchanges"
                    />
                  ))}

                </div>
                <p
                  className="mt-3 f2 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 primary1 text-end"
                  style={{ cursor: isResendEnabled ? "pointer" : "not-allowed", color: isResendEnabled ? "#007bff" : "#aaa" }}
                  onClick={handleResendOtp}
                >
                  {isResendEnabled
                    ? "Resend OTP"
                    : `Resend OTP In ${timer}s`}
                </p>
                {/* <button
                  disabled={isLoading2}
                  className="login-btn f3 mt-2 f2 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 "
                  onClick={handleConfirm}
                  style={{ color: 'black' }}
                >
                  {isLoading2 ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                        style={{ color: "black" }}
                      ></span>
                    </>
                  ) : (
                    "Continue"
                  )}

                </button> */}
                <SubmitButton
                  onClick={handleConfirm}
                  title="Continue"
                  disabled={isLoading2}
                  isFormValid={otp.join("").length !== 4}
                  loading={isLoading2}
                />
              </>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default Forgot;
